var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWilds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.59 15a.41.41 0 01.41.41c0 1.43-1.16 2.59-2.59 2.59h-.82C10.16 18 9 16.84 9 15.41a.41.41 0 01.41-.41h5.18zM9 7.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM15 7.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.883 3.187A.96.96 0 0121 4.132V13a9 9 0 01-18 0V4.132a.96.96 0 011.117-.945c5.22.87 10.547.87 15.766 0zM19.5 4.764a49.448 49.448 0 01-15 0V13a7.5 7.5 0 0015 0V4.764z",
    fill: "currentColor"
  })));
}
SvgWilds.displayName = 'Wilds';
export default SvgWilds;